var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBotonPopUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_9585",
    x: 0,
    y: 0,
    width: 81,
    height: 81,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 9,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.659
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165570",
    "data-name": "Grupo 165570",
    transform: "translate(7448 -2186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165569",
    "data-name": "Grupo 165569"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7448, 2186)",
    filter: "url(#Elipse_9585)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9585-2",
    "data-name": "Elipse 9585",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    transform: "translate(21 12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165568",
    "data-name": "Grupo 165568",
    transform: "translate(1080.5 -915.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_501",
    "data-name": "L\\xEDnea 501",
    x2: 17,
    y2: 17,
    transform: "translate(-8496.5 3124.5)",
    fill: "none",
    stroke: "#05294f",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_502",
    "data-name": "L\\xEDnea 502",
    x1: 17,
    y2: 17,
    transform: "translate(-8496.5 3124.5)",
    fill: "none",
    stroke: "#05294f",
    strokeLinecap: "round",
    strokeWidth: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotonPopUp);
export default __webpack_public_path__ + "static/media/botonPopUp.36b8dee512a27a26d3eb1a73b1b0ecdc.svg";
export { ForwardRef as ReactComponent };